module.exports = __webpack_public_path__ + "assets/5597b8f037981a9d859ceb70cec52c77.svg";